module.exports = __webpack_public_path__ + "static/UnclickOverseasAndSingapore-d0ee097e0b82944ce353e4113ff886ac.png";